import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:5000/api/v1';
export const UPLOADS_URL = import.meta.env.VITE_UPLOADS_URL || 'http://localhost:5000';

const api = axios.create({ baseURL: API_URL });

/** Resolve an image path to a full URL */
export const imgSrc = (path) => {
  if (!path) return null;
  if (path.startsWith('http')) return path;
  return `${UPLOADS_URL}${path}`;
};

/** Fetch all equipment categories (public) */
export const getEquipment = () => api.get('/equipment').then(r => r.data.data);

export default api;
